import {Injectable} from '@angular/core';
import {ListEntry, NameValueService} from '@gt-api';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {checkResponse} from '../shared/utils/app-utils';

@Injectable({
  providedIn: 'root'
})
export class GtNameValueService {
  constructor(private nameValue: NameValueService) {}

  getEndUserNameValue(name: string, oname?: string, login?: string): Observable<string> {
    return this.nameValue.getEndUserNameValue1(name, oname, login).pipe(
      checkResponse(),
      map(response => response.value)
    );
  }

  setEndUserNameValue(name: string, value: string, oname?: string, login?: string): Observable<void> {
    return this.nameValue.setEndUserNameValue1(name, value, oname, login).pipe(
      checkResponse(),
      map(() => {})
    );
  }

  getDepartmentNameValue(name: string, organization?: string, departmentId?: number): Observable<string> {
    return this.nameValue.getDepartmentNameValue1(name, organization, departmentId).pipe(
      checkResponse(),
      map(response => response.value)
    );
  }

  setDepartmentNameValue(name: string, value: string, organization?: string, departmentId?: number): Observable<void> {
    return this.nameValue.setDepartmentNameValue1(name, value, organization, departmentId).pipe(
      checkResponse(),
      map(() => {})
    );
  }

  getNameValueList(name: string, isCompanySetting = false, oname?: string, departmentId?: number, login?: string): Observable<ListEntry[]> {
    const obs = isCompanySetting
      ? this.nameValue.getDepartmentNameValueList1(name, oname, departmentId)
      : this.nameValue.getEndUserNameValueList1(name, oname, login);
    return obs.pipe(
      checkResponse(),
      map(response => response.entries)
    );
  }

  setNameValueList(
    name: string,
    list: ListEntry[],
    isCompanySetting = false,
    oname?: string,
    departmentId?: number,
    login?: string
  ): Observable<void> {
    const obs = isCompanySetting
      ? this.nameValue.setDepartmentNameValueList1(name, oname, departmentId, list)
      : this.nameValue.setEndUserNameValueList1(name, oname, login, list);
    return obs.pipe(
      checkResponse(),
      map(() => {})
    );
  }
}
